import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { userInfoStore } from '../../store/userInfoStore';

const numbersList = [1, 2, 3, 4, 5, null, 6, 7, 8, 9, 0];

const NumpadNumbers = observer(() => {
  const { betAmount, setBetAmount } = userInfoStore;

  const onChange = useCallback(
    (event) => {
      const {
        target: { value },
      } = event;
      if (/^([0]{1}|([1-9]{1}\d*))(?:\.\d{0,2})?$/.test(value)) {
        return setBetAmount(value);
      }
      if (value === '') {
        return setBetAmount(value);
      }
      return null;
    },
    [setBetAmount]
  );

  const addDigit = (digit) => {
    if (`${betAmount}${digit}`.length <= 9) {
      onChange({ target: { value: `${betAmount}${digit}` } });
    }
  };
  const deleteDigit = () => {
    onChange({ target: { value: `${betAmount}`.slice(0, -1) } });
  };

  return (
    <div className='inner-numpad-wrapper'>
      {numbersList.map((el) => {
        return (
          <div
            className={`numpad-item ${typeof el !== 'number' ? 'clear-btn-block' : ''}`}
            onClick={() => (typeof el === 'number' ? addDigit(el) : deleteDigit())}
            key={el}
          >
            <button className='numpad-btn'>
              {typeof el === 'number' ? el : <span className='icon-clear' />}
            </button>
          </div>
        );
      })}
      <div className='numpad-item dot-btn-block' onClick={() => addDigit('.')}>
        <button className='numpad-btn'>.</button>
      </div>
    </div>
  );
});
export default NumpadNumbers;
